import { Merchant, User } from '@stax-core/types-omni';
import { formatFullNameToFirstAndLastName } from './format.util';
import { getTimezoneName } from './date.util';

// from fattquery '/statistics/teamSummary' (see usage in Tracker.tsx)
export interface TeamSummary {
  charge_count_success: number;
  invoice_count: number;
  scheduled_invoice_count: number;
  customer_count: number;
  user_count: number;
  file_count: number;
  hashed_tax_id: string;
  has_qbo_pro: boolean;
  has_advanced_customization: boolean;
  has_ach: boolean;
  patial_payments_count: number;
  catalog_items_count: number;
  has_hosted_payments_transactions: boolean;
  has_integrated_transactions: boolean;
  total_amount_processed: number;
  has_logo: boolean;
  rate_type: string;
  gateways: string;
  has_qbo_lite: boolean;
}

export const initialize = (
  user: User,
  merchant: Merchant,
  teamSummary: TeamSummary,
) => {
  // variables for pendo
  const [firstName, lastName] = formatFullNameToFirstAndLastName(user.name);
  const {
    address_city: city,
    address_state: state,
    address_zip: zip,
    id,
    mid,
    brand,
    is_enterprise = false,
    company_name: omid_name,
    status,
    is_payfac,
    partner,
    product_type,
  } = merchant;

  const vertical = merchant?.options?.vertical;
  const role = user && user.team_role;
  const has_onlinereviews_enabled = !!merchant?.options?.googlePlacesId;

  // Set up Pendo
  if (process.env.REACT_APP_PENDO_KEY) {
    let p = window;
    let e = document;
    let n = 'script';
    let d = 'pendo';
    let o;
    let v, w, x, y, z;
    o = p[d] = p[d] || {};
    o._q = [];
    v = ['initialize', 'identify', 'updateOptions', 'pageLoad'];
    for (w = 0, x = v.length; w < x; ++w)
      (function (m) {
        o[m] =
          o[m] ||
          function () {
            o._q[m === v[0] ? 'unshift' : 'push'](
              // eslint-disable-next-line prefer-rest-params
              [m].concat([].slice.call(arguments, 0)),
            );
          };
      })(v[w]);
    y = e.createElement(n);
    y.async = !0;
    y.src =
      'https://cdn.pendo.io/agent/static/' +
      process.env.REACT_APP_PENDO_KEY +
      '/pendo.js';
    z = e.getElementsByTagName(n)[0];
    z.parentNode.insertBefore(y, z);
    setTimeout(() => {
      // we need the setTimeout since the pendo setup
      // actually takes some time to finish
      // and we don't have a handle onto the
      // completion of the setup process
      const hasMerchant = merchant && Object.keys(merchant).length;
      // prepending with -testing so we can blacklist from production data in pendo.
      // https://help.pendo.io/resources/support-library/installation/snippet-installation.html
      const userId = hasMerchant ? user.id : `-testing-no-merchant-${user.id}`;

      const { hashed_tax_id } = teamSummary;
      const groupId = `${hashed_tax_id}::${merchant.mid}`;

      /* eslint-disable */
      pendo.initialize({
        visitor: {
          id: userId,
          email: user.email,
          firstName,
          lastName,
          city,
          state,
          zip,
          groupId,
          timezone:
            (merchant.options && merchant.options.timezone) ||
            getTimezoneName().replace('D', 'S'),
          country: navigator.language.includes('-')
            ? navigator.language.split('-')[1]
            : navigator.language.toUpperCase(),
        },
        account: {
          id: id,
          merchant_id: id,
          mid,
          brand,
          is_enterprise,
          omid_name,
          status,
          is_payfac,
          is_iso: !is_payfac,
          partner,
          product_type,
          vertical,
          role,
          createdAt: Date.now(),
          has_onlinereviews_enabled,
          plan: merchant?.plan?.name,
          ...teamSummary,
        },
      });
    }, 1000);
  }

  let windowWithHubSpot = window as any;

  function onConversationsAPIReady(
    email: string,
    userID: string,
    omid: string,
  ) {
    var _hsq = (windowWithHubSpot._hsq = windowWithHubSpot._hsq || []);
    _hsq.push([
      'identify',
      {
        email: email,
        omni_visitor_id: userID,
        last_omid: omid,
      },
    ]);
    _hsq.push(['trackPageView']);
  }

  function sendIdentify(email: string, userID: string, omid: string) {
    if (windowWithHubSpot.HubSpotConversations) {
      onConversationsAPIReady(email, userID, omid);
    } else {
      windowWithHubSpot.hsConversationsOnReady = [
        onConversationsAPIReady(email, userID, omid),
      ];
    }
  }

  sendIdentify(user.email, user.id, merchant.id);
};
